import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from '@/router'
import { registerPlugins } from '@/plugins'
import { vCan } from '@/directives/vCan'
import { vReveal } from '@/directives/vReveal'

import '@/assets/styles/main.css'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

registerPlugins(app)

app.directive('can', vCan)
app.directive('reveal', vReveal)

app.mount('#app')
